<template>
  <section class="p-1" aria-labelledby="payment-methods-title" role="form">
    <h2 id="payment-methods-title" class="sr-only">
      {{ $t('field.paymentMethods') }}
    </h2>
    <Button v-for="method in paymenMethods" :key="method.code + (method.subCode ? '~~' + method.subCode : '')"
      :aria-label="method.description || method.code"
      class="btn btn-accordion"
      @click="() => onPaymentMethodSelected(method)"
      icon-left="credit-card"
      :aria-describedby="errorMessage ? 'payment-methods-error' : null"
      :disabled="!!errorMessage"
    >
      <span>{{ method.description || method.code }}</span>
    </Button>
    <Button
      icon-left="close"
      :secondary="true"
      @click="close"
      class="btn btn-accordion"
      :aria-label="$t('button.close')"
    >
      <span>{{ $t('button.close') }}</span>
    </Button>
  </section>
</template>

<script>
import Button from "@/components/barrier-free-template-components/Button.vue";

export default {
  components: {
    Button,
  },
  props: {
    paymenMethods: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      errorMessage: null,
    };
  },
  methods: {
    onPaymentMethodSelected(method) {
      this.errorMessage = null;
      if (method) {
        this.$emit('select', method);
      } else {
        this.errorMessage = this.$t('notification.paymentMethodSelectionError');
      }
    },
    close() {
      this.$emit('close');
    },
    handlePaymentMethodsError(error) {
      this.errorMessage = error || this.$t('notification.paymentMethodSelectionError');
    },
  },
  mounted() {
    this.$root.$on('payment-methods-error', this.handlePaymentMethodsError);
  },
  beforeDestroy() {
    this.$root.$off('payment-methods-error', this.handlePaymentMethodsError);
  },
};
</script>

<style scoped lang="scss">
@import '@/css/customizer';

.btn-accordion {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  width: 100%;
  margin: 5px 0 0;
}
</style>
